var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"archi-tree",style:({
      paddingBottom: _vm.level === 0 ? '4px' : 0
    })},_vm._l((_vm.renderData),function(item){return _c('div',{key:item.id},[_c('ArchiItem',{style:({
          padding: '0 16px',
          paddingLeft: _vm.level > 0 ? (_vm.level + 1) * 16 + 'px' : '16px',
        }),attrs:{"archiData":item,"level":_vm.level + 1},nativeOn:{"click":function($event){return _vm.onToggle(item)}}}),(item.children && item.children.length)?[_c('ArchiTree',{directives:[{name:"show",rawName:"v-show",value:(item.showChildren),expression:"item.showChildren"}],attrs:{"level":_vm.level + 1,"treeData":item.children}})]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }